module.exports = __webpack_public_path__ + "img/2.351be713.png";